import { useState, useRef, useEffect } from 'react';
import { HelpCircle, BookOpen, MessageCircleQuestion } from 'lucide-react';
import TutorialSelector from '../tutorial/TutorialSelector';
import FaqPanel from '../help/FaqPanel';
import { useTutorial } from '../../context/TutorialContext';

/**
 * HelpMenu — icône "?" dans le header + popover avec Tutoriels / FAQ
 */
const HelpMenu = () => {
    const { activeTutorial } = useTutorial();
    const [menuOpen, setMenuOpen] = useState(false);
    const [tutorialOpen, setTutorialOpen] = useState(false);
    const [faqOpen, setFaqOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!menuOpen) return;
        const onClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, [menuOpen]);

    // Caché pendant un tutoriel actif
    if (activeTutorial) return null;

    return (
        <>
            <div ref={menuRef} style={{ position: 'relative' }}>
                <button
                    onClick={() => setMenuOpen(v => !v)}
                    className="flex items-center justify-center min-w-11 min-h-11 sm:min-w-0 sm:min-h-0 p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-purple-600"
                    title="Aide"
                    aria-label="Aide"
                >
                    <HelpCircle className="w-5 h-5" />
                </button>
                {menuOpen && (
                    <div
                        style={{
                            position: 'absolute',
                            right: 0,
                            top: '110%',
                            minWidth: 180,
                            backgroundColor: 'white',
                            borderRadius: 12,
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                            padding: 6,
                            zIndex: 1000
                        }}
                    >
                        <button
                            onClick={() => { setMenuOpen(false); setTutorialOpen(true); }}
                            className="w-full text-left px-3 py-2 rounded-lg hover:bg-gray-100 flex items-center gap-2 text-sm text-gray-700"
                        >
                            <BookOpen className="w-4 h-4 text-purple-600" />
                            Tutoriels
                        </button>
                        <button
                            onClick={() => { setMenuOpen(false); setFaqOpen(true); }}
                            className="w-full text-left px-3 py-2 rounded-lg hover:bg-gray-100 flex items-center gap-2 text-sm text-gray-700"
                        >
                            <MessageCircleQuestion className="w-4 h-4 text-purple-600" />
                            FAQ
                        </button>
                    </div>
                )}
            </div>
            <TutorialSelector isOpen={tutorialOpen} onClose={() => setTutorialOpen(false)} />
            <FaqPanel isOpen={faqOpen} onClose={() => setFaqOpen(false)} />
        </>
    );
};

export default HelpMenu;
